export default __webpack_public_path__ + "static/media/android.088fe747.svg";